module.exports = __webpack_public_path__ + "img/p1-c2-p5.151e58aa.jpg";